import React from "react";
import { inject } from "mobx-react";

import { DefaultLayout } from "shared/components";

import { default as CodeMapPanel } from "./components/code-map-panel";

@inject("rootStore")
class ChangePasswordPanelPage extends React.Component {
  render() {
    const { rootStore } = this.props;
    return (
      <DefaultLayout>
        <CodeMapPanel rootStore={rootStore} />
      </DefaultLayout>
    );
  }
}
export default ChangePasswordPanelPage;
